import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { News } from '../../../data/news/domain/news';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-news-popup',
  templateUrl: './news-popup.component.html',
  styleUrls: ['./news-popup.component.scss'],
})
export class NewsPopupComponent {
  @Input() public news: News[] = [];
  @Output() result = new EventEmitter<{ checkbox: boolean; action?: string }>();
  checkbox = false;

  constructor(private bsModalRef: BsModalRef, private router: Router) {
    // Nada
  }

  hideModal() {
    this.result.emit({ checkbox: this.checkbox });
    this.bsModalRef.hide();
  }

  public distinctTitle(news: News[]): string[] {
    return [...new Set(news.map((n) => n.title))];
  }

  public getArticles(news: News[], filter: string) {
    return news.filter((n) => n.title === filter);
  }

  doAction(action: string) {
    this.result.emit({ checkbox: this.checkbox, action });
    this.bsModalRef.hide();
  }

  labelAction(action: string) {
    const levelOne = action.split('#');
    const levelTwo = levelOne[0].split(':');
    return levelTwo[1];
  }
}
